import React from "react";
import HowtoApplySection from "../../Sections/HowtoApplySection/Content";
const HowtoApplyPage = () => {
  return <HowtoApplySection />;
};

export default HowtoApplyPage;
